export default "__VITE_ASSET__Dr0ORoJ9__"